import React from 'react'
import styled from 'styled-components'

// RailHeader component for displaying rail header.
const RailHeader = ({ channelLogo, channelNumber }) => {
  // let logoS = "https://pmd205470tn-a.akamaihd.net/D2C_Partner_-_Diagnal_Sales_Demo_(ERA_3.0)/477/945/SixxAT__347030.png"
  return (
    <RailHeaderStyled className="channel-rail-header">
      <img className="header-logo" src={channelLogo} alt="imag" />
      <div className="episode-number">{channelNumber ? channelNumber : '121'}</div>
    </RailHeaderStyled>
  )
}

const RailHeaderStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-content: center;
    
     width: 100%;
     background-color : #000000;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      padding: 11px;
     
    
     
    



     .header-logo{
       height:25px;
       max-width: 50%;
     }
     .episode-number{
       margin-left: auto;
       color: #7B7B7B;
       font-size: 18px;
       padding-top: 5px;
       margin-right: 10px;      
     }
`


export default RailHeader